import i18next from 'i18next';
import React from 'react';

import {Select} from '@famly/mf_input_select';
import {FormControl} from '@famly/mf_input_form-control';
import {Button} from '@famly/mf_input_button';
import {Stack} from '@famly/mf_layout_stack';

import type * as Types from '../types';
import {OptionAdornment} from './option-adornment';

type SelectedBillingPeriod = Types.State['billingPeriodState']['selectedBillingPeriod'];
type Props = {
    onChange: Types.HandleBillingPeriodChange;
    editCustomPeriod: VoidFunction;
    selectedBillingPeriod: SelectedBillingPeriod;
    isDisabled: boolean;
    options: Array<Types.BillingPeriodOption>;
};

const BillingPeriodSelect = ({onChange, editCustomPeriod, selectedBillingPeriod, options, isDisabled}: Props) => {
    return (
        <FormControl fullWidth label={i18next.t('react.simplifiedUsBillingPlan.translations.json.billingPeriod')}>
            <Stack alignItems="center" gap={2}>
                <Select
                    fullWidth
                    disabled={isDisabled}
                    onChange={onChange}
                    options={options}
                    value={selectedBillingPeriod?.startDate?.numericFormat ?? null}
                    getOptionAdornment={option => {
                        if (option.type === 'custom') {
                            return option.from && option.to ? (
                                <OptionAdornment>{`${option.from}-${option.to}`}</OptionAdornment>
                            ) : undefined;
                        }
                        return option.type === 'monthly' ? (
                            <OptionAdornment>{`${option?.from} - ${option?.to}`}</OptionAdornment>
                        ) : undefined;
                    }}
                    data-e2e-id="first-billing-period-select"
                />
                {selectedBillingPeriod?.type === 'custom' ? (
                    <Button
                        variant="transparent"
                        icon="edit"
                        onClick={editCustomPeriod}
                        aria-label="Edit custom billing period"
                        data-e2e-id="edit-custom-period-button"
                    />
                ) : null}
            </Stack>
        </FormControl>
    );
};

export {BillingPeriodSelect};
